<dx-popup
  [(visible)]="showModal"
  [width]="400"
  [height]="'auto'"
  [dragEnabled]="false"
  [showTitle]="true"
  [title]="'PERIODS.CUSTOM' | translate"
  [hideOnOutsideClick]="true"
  (onHidden)="onPopupClosed()">
  <br>
    <dx-date-range-box
      [min]="minDate"
      [max]="maxDate"
      [(value)]="range"
      labelMode="floating"
      [useMaskBehavior]="true"
      [showClearButton]="true"
      [openOnFieldClick]="false"
      [displayFormat]="'dd.MM.yyyy'"
    >
    </dx-date-range-box>
    <div class="button-container">
        <dx-button
            [text]="'COMMON.APPLY' | translate"
            type="default"
            stylingMode="contained"
            (onClick)="apply()">
        </dx-button>
    </div>
</dx-popup>